import { c as _c } from "react/compiler-runtime";
import { SvgCalendarFill, SvgLocationPinFill } from '@common/icon';
import { CustomLink } from '@/app/_components/CustomLink';
import type { ThemeFestival } from '@/app/(allowed)/festival/_utils/festivalFetchers';
import { Image } from '@/components/client';
import { FestivalStatusBadge } from '@/components/molecule/FestivalStatusBadge';
import { PLACEHOLDER_THUMBNAIL, ROUTES } from '@/constants';
import { formatDateRange } from '@/utils/formatDateRange';
import { formatDistanceLabel } from '@/utils/formatDistanceLabel';
interface FestivalCardProps {
  festival: ThemeFestival;
  preload?: boolean;
}
export const FestivalCard = t0 => {
  const $ = _c(36);
  const {
    festival,
    preload
  } = t0;
  if (!festival.id) {
    return null;
  }
  const place = festival.eventplace || festival.addr1;
  let t1;
  if ($[0] !== festival.distance) {
    t1 = typeof festival.distance !== "number" ? null : formatDistanceLabel(festival.distance);
    $[0] = festival.distance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const distanceLabel = t1;
  let t2;
  if ($[2] !== festival.id || $[3] !== festival.slugId) {
    t2 = ROUTES.FESTIVAL_DETAIL.pathname({
      idIdx: festival.slugId ?? festival.id
    });
    $[2] = festival.id;
    $[3] = festival.slugId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = festival.firstImage || festival.firstImage2 || PLACEHOLDER_THUMBNAIL;
  const t4 = festival.title ?? "";
  let t5;
  if ($[5] !== preload || $[6] !== t3 || $[7] !== t4) {
    t5 = <Image src={t3} alt={t4} fill={true} sizes="(max-width: 1280px) 50vw, 254px" className="object-cover" preload={preload} unoptimized={true} />;
    $[5] = preload;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div aria-hidden="true" className="absolute inset-0 bg-Gray-black/0 transition-colors duration-300 ease-out group-hover:bg-Gray-black/5" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== festival.status) {
    t7 = festival.status ? <FestivalStatusBadge status={festival.status} className="absolute left-16 top-16" /> : null;
    $[10] = festival.status;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== festival.isNew) {
    t8 = festival.isNew ? <span className="absolute right-16 top-16 inline-flex items-center rounded-xsmall bg-O-500 px-6 py-2 font-700 text-Gray-white typo-caption1">NEW</span> : null;
    $[12] = festival.isNew;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t7 || $[16] !== t8) {
    t9 = <div className="relative aspect-[343/268] w-full overflow-hidden rounded-xsmall bg-Gray-100 mobile:rounded-medium">{t5}{t6}{t7}{t8}</div>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== festival.title) {
    t10 = <h3 className="m-0 truncate font-600 text-Gray-black typo-body3">{festival.title}</h3>;
    $[18] = festival.title;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== festival.eventenddate || $[21] !== festival.eventstartdate) {
    t11 = festival.eventstartdate && festival.eventenddate ? <div className="flex items-center gap-8"><SvgCalendarFill className="size-16 shrink-0 text-Gray-400" /><span className="flex-1">{formatDateRange(festival.eventstartdate, festival.eventenddate)}</span></div> : null;
    $[20] = festival.eventenddate;
    $[21] = festival.eventstartdate;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== distanceLabel || $[24] !== place) {
    t12 = place || distanceLabel ? <div className="flex items-center gap-8"><SvgLocationPinFill className="size-16 shrink-0 text-Gray-400" />{place ? <span className="min-w-0 truncate">{place}</span> : null}{place && distanceLabel ? <span aria-hidden="true" className="size-2 shrink-0 rounded-pill bg-Gray-300" /> : null}{distanceLabel ? <span className="shrink-0 font-600 text-Gray-800">{distanceLabel}</span> : null}</div> : null;
    $[23] = distanceLabel;
    $[24] = place;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <div className="flex flex-col gap-4 py-4 text-Gray-600 typo-caption1 mobile:typo-body4">{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t13) {
    t14 = <div className="flex flex-col">{t10}{t13}</div>;
    $[29] = t10;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t2 || $[34] !== t9) {
    t15 = <CustomLink href={t2} className="group flex w-full flex-col gap-12 rounded-medium transition-opacity duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500 active:opacity-80">{t9}{t14}</CustomLink>;
    $[32] = t14;
    $[33] = t2;
    $[34] = t9;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};